/**
 * ErrorBoundary — top-level crash guard for the authenticated app tree.
 *
 * Extracted from App.js (shell split) — BYTE-IDENTICAL body. Catches render
 * errors below it and swaps in a recover-to-home fallback instead of a blank
 * white screen. Mounted around <AuthenticatedApp> in App.js.
 */
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('App error:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'system-ui' }}>
          <h2>Something went wrong</h2>
          <p>Please refresh the page or go back to the home screen.</p>
          <button
            onClick={() => { this.setState({ hasError: false }); window.location.href = '/'; }}
            style={{ padding: '10px 24px', borderRadius: '8px', background: '#059669', color: '#fff', border: 'none', cursor: 'pointer', fontSize: '16px' }}
          >
            Go Home
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
